import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { getResponsiveTypographyStyles } from "./Typography";

// see for button typography sizing
// https://m3.material.io/styles/typography/applying-type#af6eb002-9cbb-4b64-bce6-1315d2252364

declare module "@mui/material/Button" {
    interface ButtonPropsColorOverrides {
        buttonPrimary: true;
        buttonSecondary: true;
    }
}

export type ButtonProps = {
    children: React.ReactNode;
    color?: MuiButtonProps["color"] | "light";
    target?: string;
} & Omit<MuiButtonProps, "children" | "color">;
export const Button = ({ children, color, ...props }: ButtonProps) => {
    return (
        <ButtonStyled data-color={color} color={mapColor(color)} disableElevation={true} {...props}>
            {children}
        </ButtonStyled>
    );
};

function mapColor(color: MuiButtonProps["color"] | "light") {
    if (color === "light") {
        return undefined;
    }
    if (color === "primary") {
        return "buttonPrimary";
    }
    if (color === "secondary") {
        return "buttonSecondary";
    }
    return color;
}

const ButtonStyled = styled(MuiButton)(({ theme }) => ({
    textTransform: "none",

    ...getResponsiveTypographyStyles(theme, "label", "large"),
    "&[data-color='light']": {
        color: "white",
        borderColor: "white",
    },
    "&[data-color='subtle']": {
        color: theme.palette.text.secondary,
        borderColor: "white",
    },
}));
